import { useTranslation } from 'src/../i18n';
import { useEffect } from 'react';
import { IDealer } from 'src/interfaces/Dealer';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useDispatch, useSelector } from 'react-redux';
import { Redux } from 'src/redux/redux.interface';
import DealerDuck from 'src/redux/dealer/dealer.duck';
import { getCurrentCulture } from '@utils/getCurrentCulture';
import { dealerApi } from 'src/services';
import { validateDealerId } from '@utils/Deal.utils';

export const useGetDealerInformation = (): IDealer => {
    const { carDetails, currentDeal } = useCarDetailsDuck();
    const dispatch = useDispatch();
    const dealer = useSelector((state: Redux) => DealerDuck.getOwnState(state).dealer);
    const { i18n } = useTranslation();
    const { currentCulture } = getCurrentCulture(i18n);

    useEffect(() => {
        if (
            !carDetails?.dealers?.length &&
            !Object.values(dealer || {})?.filter(Boolean)?.length &&
            validateDealerId(currentDeal?.dealerId)
        ) {
            dealerApi.getDealer(currentDeal.dealerId).then(({ data }) => dispatch(DealerDuck.setDealer(data)));
        }
    }, [dealer, carDetails, currentDeal]);

    if (carDetails?.dealers?.length > 0) {
        const dealerName = carDetails?.dealers?.[0]?.name?.[currentCulture];

        const { city, line1: street, zipCode } = carDetails.dealers[0].address?.[currentCulture];
        const { distance, email, phoneNumber, coordinates, siretNumber, openingHoursList } = carDetails.dealers[0];
        const address = { zipCode, city, line1: street };
        const openingHours = openingHoursList?.[currentCulture];

        return {
            city,
            street,
            distance,
            email,
            phoneNumber,
            zipCode,
            coordinates,
            dealerName,
            openingHours,
            siretNumber,
            address,
        };
    }

    return {
        city: dealer?.city,
        zipCode: dealer?.postCode,
        street: dealer?.streetName,
        openingHours: dealer?.openingHours,
        siretNumber: dealer?.numSiret,
        dealerName: dealer?.name,
    };
};
